import { useQuery } from "react-query";
import { AppliedKandidatResponse } from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchAllAppliedJobKey = "all-applied-job-key";

export async function fetchAllAppliedJob(): Promise<AppliedKandidatResponse[]> {
  const res = await ApiClient.get(`/AllAppliedJob`);
  return res.data;
}

export default function useFetchAllAppliedJob() {
  return useQuery([fetchAllAppliedJobKey], queryWrapper(fetchAllAppliedJob));
}
